export const loadTooltip = () => {
  let element = document.getElementsByName("tooltip")
  // console.log("Tooltip Loaded")

  if (innerWidth < 1024) {
    element.forEach((elem) => elem.setAttribute("data-tooltip", elem.id))
  } else {
    element.forEach((elem) => elem.removeAttribute("data-tooltip", elem.id))
  }
}
